import { render } from "./navbar.vue?vue&type=template&id=688b5e20&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=688b5e20&lang=less&scoped=true"
/* hot reload */
if (module.hot) {
  script.__hmrId = "688b5e20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('688b5e20', script)) {
    api.reload('688b5e20', script)
  }
  
  module.hot.accept("./navbar.vue?vue&type=template&id=688b5e20&scoped=true", () => {
    api.rerender('688b5e20', render)
  })

}


import exportComponent from "D:\\develop\\simo\\front\\website\\front-bc-huibentong-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688b5e20"],['__file',"src/components/navbar.vue"]])